import type { MetricsResponse } from "@shared/types";
import { TileCard } from "./TileCard";
import { formatInteger, formatPaiseAsRupees } from "@/lib/format";

interface CallCapMeterProps {
  callCap: MetricsResponse["callCap"];
}

export function CallCapMeter({ callCap }: CallCapMeterProps) {
  const { used, limit, overageRate } = callCap;
  const pct = limit > 0 ? (used / limit) * 100 : 0;
  const tone: "green" | "amber" | "red" =
    pct >= 100 ? "red" : pct >= 80 ? "amber" : "green";

  const width = Math.min(pct, 100);

  return (
    <TileCard label="Call cap · this month" testId="tile-call-cap">
      <div className="meter-headline">
        <span data-testid="cap-used">{formatInteger(used)}</span>
        <span className="meter-total">
          / {formatInteger(limit)} calls
        </span>
      </div>
      <div
        className="meter"
        role="progressbar"
        aria-valuenow={Math.round(pct)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="call cap usage"
      >
        <div
          className={`meter-fill meter-fill--${tone}`}
          data-testid="cap-meter-fill"
          data-tone={tone}
          style={{ width: `${width}%` }}
        />
      </div>
      <div className="tile-footer">
        Overage billed at {formatPaiseAsRupees(overageRate)}/call
      </div>
    </TileCard>
  );
}
